(ns rothko.footer.component
  (:require [reagent.core :as reagent]))

(defn footer
  [{:keys [appearance content on-hide-footer on-show-footer]
    :or {on-show-footer (constantly :no-op)
         on-hide-footer (constantly :no-op)}}]
  (reagent/create-class
   {:display-name "footer"
    :component-did-mount
    (fn [this _]
      (on-show-footer))

    :component-will-unmount
    (fn [this _]
      ;; TODO: The below comment came from the sandi component, not sure whether
      ;; it's still relevant:
      ;; This doesn't seem to be working - possibly due to the way kee-frame
      ;; transitions routes?
      (on-hide-footer))

    :reagent-render
    (fn [{:keys [appearance content]}]
      (into [:footer {:class appearance}] content))}))
